export const fi = {
  // Certificate Headers
  congrats_message: "Wifi-asennuksesi on valmis ja RouteThis:in todentama.",
  installation_details: "Asennuksen yksityiskohdat",
  wireless_speed_test: "Langattoman nopeuden testaus",
  wireless_performance: "Wireless Performance",
  photos: "Valokuvat",
  signal_maps: "Signaalikartat",
  wifi_information: 'WiFi Information',

  // Certificate Room Names
  singular_room: "Huoneen",
  room_type_bathroom: "Kylpyhuone",
  room_type_bedroom: "Makuuhuone",
  room_type_dining_room: "Ruokasali",
  room_type_entry_or_hall: "Eteinen",
  room_type_garage: "Autotalli",
  room_type_kitchen: "Keittiö",
  room_type_living_room: "Olohuone",
  room_type_office: "Työhuone",
  room_type_other: "Muu",

  // Pod Name
  pod_1: "Mesh pod",
  pod_2: "Tukiasema",
  pod_3: "Mesh node",
  pod_4: "Mesh puck",
  pod_5: "Majakka",
  pod_6: "Mesh pod",
  pods_1: "Mesh podit",
  pods_2: "Tukiasemat",
  pods_3: "Mesh nodet",
  pods_4: "Mesh puckit",
  pods_5: "Majakat",
  pods_6: "Mesh podit",

  // Router Name
  router_1: "Reititin",
  router_2: "Modeemi",
  router_3: "Yhdyskäytävä",
  router_4: "Keskitin",
  router_5: "Reititin",

  // Level Name
  level_1: "Taso",
  level_2: "Kerros",
  levels_1: "Tasot",
  levels_2: "Kerrokset",

  // Certificate Pod Info
  recommended: "Suositeltu",
  installed: "Asennettu",
  total: "Yhteensä",

  // Certificate Signal Table
  front_building: "Talon edusta",
  speed: "Nopeus",
  video: "Video",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Linkki",
  frequency_short: "Taajuus",
  frequency_description: "MHz",
  channel_short: "Kanal",

  // Certificate Legend
  legend: "Selite",
  measured_speed: "Mitattu nopeus",
  measured_speed_description: "Mbit/s",

  // Certificate Speedtest Result
  speedtest_passed: "Nopeus on useimmilta mobiililaitteilta odotetulla välillä. Kaikki langattomat laitteet eivät pysty saavuttamaan liittymään kuuluvaa maksiminopeutta. Katso alempaa yksittäisten huoneiden testaus.",
  speedtest_failed: "Testattu puhelimella tai tabletilla. Kaikki langattomat laitteet eivät pysty saavuttamaan liittymään kuuluvaa maksiminopeutta. Katso alempaa yksittäisten huoneiden testaus.",
}